module.exports = __webpack_public_path__ + "assets/ghost.7b551742.svg";